import React, { useEffect } from "react";

import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";

import {
  PLQuater,
  PLQuaterFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Profit And Loss/ProfitAndLossSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function Quater({ selectedIds = "" }) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { PLQuaterdata } = useSelector((state) => state.ProFitAndLossSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");
  const Year = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(PLQuaterFan());
    dispatch(
      PLQuater({
        Firm,
        Year,
        selectedIds,
      }),
    );
  }, [dispatch, Firm, Year, selectedIds]);

  
  /* ================= FORMAT ================= */

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
    

  /* ================= DATA ================= */

  const getRows =
    PLQuaterdata?.Detail?.map((label, index) => ({
      srNumber: index + 1,
      AcName: label.AcName,
      GroupMStName: label.GroupMStName,
      AcLaieName: label.AcLaieName,
      GroupSeq: label.GroupSeq,
      Quater1st: label.Quater1st,
      Quater2nd: label.Quater2nd,
      Quater3rd: label.Quater3rd,
      Quater4th: label.Quater4th,
    })) || [];

  /* ================= COLUMNS ================= */

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
      width: "180px",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "GroupSeq", key: "GroupSeq", align: "right" },
    { label: "Q1", key: "Quater1st", align: "right", format: true },
    { label: "Q2", key: "Quater2nd", align: "right", format: true },
    { label: "Q3", key: "Quater3rd", align: "right", format: true },
    { label: "Q4", key: "Quater4th", align: "right", format: true },
  ];

  /* ================= PDF ================= */

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Profit & Loss - Quarter Wise Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME ================= */
    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    doc.setFontSize(12); // Title jitni size
    doc.setFont(undefined, "bold"); // Title jaisa bold

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });
    /* ================= DATA ================= */
    const details = PLQuaterdata?.Detail || [];

    let totals = {
      Quater1st: 0,
      Quater2nd: 0,
      Quater3rd: 0,
      Quater4th: 0,
    };

    const formatIndianRupee = (amount) =>
      new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount || 0);

    const tableRows = details.map((row, index) => {
      totals.Quater1st += Number(row.Quater1st || 0);
      totals.Quater2nd += Number(row.Quater2nd || 0);
      totals.Quater3rd += Number(row.Quater3rd || 0);
      totals.Quater4th += Number(row.Quater4th || 0);

      return [
        index + 1,
        row.AcLaieName || "",
        row.GroupMStName || "",
        row.AcName || "",
        row.GroupSeq || "",
        formatIndianRupee(row.Quater1st || 0),
        formatIndianRupee(row.Quater2nd || 0),
        formatIndianRupee(row.Quater3rd || 0),
        formatIndianRupee(row.Quater4th || 0),
      ];
    });

    /* ================= TOTAL ROW ================= */
    tableRows.push([
      "",
      "",
      "",
      "TOTAL",
      "",
      formatIndianRupee(totals.Quater1st),
      formatIndianRupee(totals.Quater2nd),
      formatIndianRupee(totals.Quater3rd),
      formatIndianRupee(totals.Quater4th),
    ]);

    /* ================= COLUMN WIDTH ================= */
    const columnWidths = [10, 25, 35, 45, 20, 25, 25, 25, 25];

    const tableWidth = columnWidths.reduce((a, b) => a + b, 0);
    const startX = (pageWidth - tableWidth) / 2;

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY: 32,
      margin: { left: startX, right: startX },

      head: [
        [
          "Sr",
          "Ac Type",
          "AcGroup",
          "Ac Name",
          "GroupSeq",
          "Q1",
          "Q2",
          "Q3",
          "Q4",
        ],
      ],

      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },

      columnStyles: {
        0: { halign: "center", cellWidth: columnWidths[0] },
        1: { halign: "left", cellWidth: columnWidths[1] },
        2: { halign: "left", cellWidth: columnWidths[2] },
        3: { halign: "left", cellWidth: columnWidths[3] },
        4: { halign: "center", cellWidth: columnWidths[4] },

        5: { halign: "right", cellWidth: columnWidths[5] },
        6: { halign: "right", cellWidth: columnWidths[6] },
        7: { halign: "right", cellWidth: columnWidths[7] },
        8: { halign: "right", cellWidth: columnWidths[8] },
      },

      didParseCell: (data) => {
        if (data.row.raw[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },

      showHead: "everyPage",

      didDrawPage: () => {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;
        doc.setFontSize(8);
        doc.text(`Page ${pageNo}`, marginX, pageHeight - 5);
      },
    });

    /* ================= SUMMARY ================= */
    const summary = PLQuaterdata?.Summary?.[0] || {};
    const finalY = doc.lastAutoTable.finalY + 10;

    doc.setFontSize(11);
    doc.setFont(undefined, "bold");

    doc.text(`Status : ${summary.Status || ""}`, marginX, finalY);

    doc.text(
      `Amount : ${formatIndianRupee(summary.Amount || 0)}`,
      pageWidth - marginX,
      finalY,
      { align: "right" },
    );

    doc.line(marginX, finalY + 3, pageWidth - marginX, finalY + 3);

    doc.save("PL_Quarter_Wise_Report.pdf");
  };

  /* ================= LOADER ================= */

  if (PLQuaterdata === "no" || PLQuaterdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  /* ================= UI ================= */

  return (
    <div>
      <Row>
        <Col xs={12}>
          <Row
            className="align-items-center"
            style={{
              marginBottom: "10px",
            }}
          >
            {/* Card */}
            <Col xl={6} lg={8} md={12} sm={12}>
              <div
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour2,
                  border: `1px solid ${
                    isdark === "light"
                      ? iscolour?.Colour3
                      : iscolourDark?.Colour10
                  }`,
                  borderLeft: `6px solid ${
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour10
                  }`,
                  borderRadius: "12px",
                  padding: "12px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  height: "100%",
                }}
              >
                {/* Amount */}
                <h4
                  style={{
                    marginTop: "10px",
                    fontWeight: "500",
                    color:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour10,
                  }}
                >
                  {formatIndianRupee(PLQuaterdata?.Summary?.[0]?.Amount)}
                </h4>

                {/* Title */}
                <h6
                  style={{
                    color:
                      isdark === "light"
                        ? iscolour?.Colour12
                        : iscolourDark?.Colour12,
                    fontWeight: "600",
                  }}
                >
                  {PLQuaterdata?.Summary?.[0]?.Status} Amount :{" "}
                </h6>
              </div>
            </Col>

            {/* Button */}
            <Col
              xl={6}
              lg={4}
              md={12}
              sm={12}
              className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-start mt-md-3 mt-3 mt-lg-0"
            >
              <button
                onClick={handleDownload}
                className="common-hover-btn"
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour4
                      : iscolourDark?.Colour6,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour11
                      : iscolourDark?.Colour12,
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "14px",
                  height: "44px",
                }}
              >
                <Download size={16} />
                Download PDF
              </button>
            </Col>
          </Row>

          <div
            style={{
              marginTop: "20px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour11,
                padding: "14px",
                margin: 0,
                position: "relative",
                zIndex: 2,
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                }}
              >
                QUARTER
              </h2>
            </div>

            {/* <FASparentMultipalChild
              data={getRows}
              columns={getColumns}
              externalTotals={PLQuaterdata?.Summary?.[0] || {}}
            /> */}

            <FASparentMultipalChild
              data={getRows}
              columns={getColumns}
              externalTotals={PLQuaterdata?.Summary?.[0] || {}}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
